import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PastStatement from "../../components/payroll_components/user/PastStatement";
import BackButton from "../../components/constant_components/BackButton";
import axiosClient from "@service/axiosClient";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const StatementHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [stubs, setStubs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const stubResponse = await axiosClient.get(
          `/api/worker/${id}/paystubs/12`
        );
        setStubs(stubResponse.data);
      } catch (error) {
        console.error("Error fetching stub history data:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center", // Center the content vertically
          borderBottom: "1px solid black",
          height: "3.5em",
          backgroundColor: "hsl(230, 68%, 47%)",
          color: "white",
        }}
      >
        <BackButton />
        <Typography
          variant="h4"
          sx={{
            fontStyle: "bold", // Use bold font style
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem", lg: "3rem" }, // Adjust font size based on breakpoints
            // color: 'hsl(230, 68%, 47%)'
          }}
        >
          {t("statementHistory.title")}
        </Typography>
      </Box>
      {stubs === null || stubs.length === 0 ? (
        <h2>{t("statementHistory.noStatements")}</h2>
      ) : (
        stubs
          .sort((a, b) => new Date(b.pay_date) - new Date(a.pay_date)) // Sort stubs by pay_date in descending order
          .map((stub) => <PastStatement key={stub.id} stub={stub} />)
      )}
    </Box>
  );
};
